@if (energyToolFacade.energyToolDisabled()) {
  <ngx-simplebar [options]="{ autoHide: false }" style="grid-row: 1/3" class="widget flex flex-column gap-3 p-3">
    <div class="flex gap-1 align-items-center">
      <app-svg-icon style="display: flex" iconName="info-circle" iconColor="primary"></app-svg-icon>
      <span>{{ "energy_tool.tool_disabled.title" | translate }}</span>
    </div>

    <span class="font-size-sm">{{ "energy_tool.tool_disabled.description" | translate }}</span>
  </ngx-simplebar>
} @else {
  <ngx-simplebar [options]="{ autoHide: false }" class="widget gateSystemName">
    @if (timeOut()) {
      <app-timeout></app-timeout>
    } @else {
      @if (gateSystemRefLoading()) {
        <div class="flex justify-content-center">
          <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
        </div>
      } @else if (energyToolFacade.gateSystemRef() === undefined) {
        {{ "common.no_data" | translate }}
      } @else if (energyToolFacade.gateSystemRef() !== null && energyToolFacade.gateSystemRef() !== undefined) {
        <div class="flex gap-1 flex-column font-size-sm">
          <span class="energyToolWidgetTitle">{{ "energy_tool.gate_system" | translate }}</span>
          <span>{{
            energyToolFacade.gateSystemRef()!
              | gateIdentifier: permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
          }}</span>
        </div>
      }
    }
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget tempDisplay">
    <app-temperature-display
      [insideTemperature]="energyToolFacade.insideTemp()"
      [outsideTemperature]="energyToolFacade.outsideTemp()"
    ></app-temperature-display>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget expectedEnergyLoss">
    <app-expected-energy-loss
      [energyLoss]="energyToolFacade.energyLoss()"
      [expectedEnergyLossPerDay]="energyToolFacade.expectedEnergyLossPerDay()"
      [energyCost]="energyToolFacade.energyCost()"
      (changeTimeframeEvent)="onChangeTimeExpecteEnergyLoss($event)"
    ></app-expected-energy-loss>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget loadChanges">
    <app-load-changes
      [loadChanges]="$safeNavigationMigration(energyToolFacade.cycle()?.value)"
      [lastActionTimestamp]="$safeNavigationMigration(energyToolFacade.cycle()?.timestamp)"
      (changeTimeframeEvent)="onChangeTimeCycle($event)"
    ></app-load-changes>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget openDuration">
    <app-open-duration
      [longestOpenDuration]="energyToolFacade.longestOpenDuration()"
      [lastOpenDuration]="energyToolFacade.lastOpenDuration()"
      [gatePosition]="$safeNavigationMigration(energyToolFacade.gatePositionDuration()?.value)"
      [gatePositionTimestamp]="$safeNavigationMigration(energyToolFacade.gatePositionDuration()?.timestamp)"
    ></app-open-duration>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget gatePosition">
    <app-gate-position
      [gateStatus]="energyToolFacade.gateStatus()"
      [timeout]="energyToolFacade.gateStatusTimeout()"
      [lastActionTimestamp]="energyToolFacade.gatePositionState()?.timestamp"
    ></app-gate-position>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget weatherReport">
    <app-weather-report
      [sourceType]="sourceType"
      [forecastWeatherData]="energyToolFacade.forecastWeather()"
      [forecastEnergyLossData]="energyToolFacade.forecastEnergyLoss()"
    ></app-weather-report>
  </ngx-simplebar>

  <ngx-simplebar [options]="{ autoHide: false }" class="widget barChart">
    <app-bar-chart
      [chartData]="energyToolFacade.barChartEnergyLoss()"
      (changeTimeframeEvent)="onChangeTimeBarChart($event)"
      [sourceType]="sourceType"
      [sourceId]="sourceId"
      chartId="gateSystemBarChart"
    ></app-bar-chart>
  </ngx-simplebar>

  <ngx-simplebar [options]="{ autoHide: false }" class="widget lineChart">
    <app-line-chart
      [chartData]="energyToolFacade.lineChartEnergyLoss()"
      (changeTimeframeEvent)="onChangeTimeLineChart($event)"
      [sourceType]="sourceType"
      [sourceId]="sourceId"
      chartId="gateSystemLineChart"
    ></app-line-chart>
  </ngx-simplebar>
}
